import React from "react";

function TotalVotes({ totalVotes}) {
  return <div className="total-votes">Votes {totalVotes}</div>;
}

export { TotalVotes };
